import { useWindowSize } from 'usehooks-ts';

export const useGetBreakPointReached = (limit: number) => {
  const { width } = useWindowSize();
  const limitReached = width < limit;
  return limitReached;
};
